var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.decreaseQuantity}},[_c('v-icon',[_vm._v("mdi-minus")])],1),_c('span',[_vm._v("{quantity}")]),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.increaseQuantity}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }